exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".borclu-report-table[data-v-0b4d1de4]{width:100%;margin-top:8px}.borclu-report-cell[data-v-0b4d1de4]{width:100%;min-height:34px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.borclu-report-table>*[data-v-0b4d1de4]{width:100%}", ""]);

// exports
